import React, { useEffect, useState } from 'react';
import swal from "sweetalert";
import $ from 'jquery';
import { useWallet } from '../WalletProvider';
import { baseUrl } from "../../common"

function PurchaseBox(props) {
    const {duration,handleShowTimer} = props;
    const [fee , setFee] = useState(0)
    const {account, currencyDetails } = useWallet();
    const queryParams = new URLSearchParams(window.location.search)
    const currency = queryParams.get("currency")

    const saveVip = async(address, tx,fee,)=>{
        const end = await currencyDetails.airDropContract.methods.membershipExpiryTime(account).call();
        var settings = {
            "url": `${baseUrl}/add-vip`,
            "method": "POST",
            "timeout": 0,
            "headers": {
              "Content-Type": "application/x-www-form-urlencoded"
            },
            "data": {
              "address": address,
              "txHash": tx,
              "amount": (Number(fee/10**18)),
              "endTime": Number(end)
            }
          };
          
          $.ajax(settings).done(function (response) {
            if(response.success === true){
                handleShowTimer(true)
                $('.ajax-loader').css("display", "none");
                setTimeout(() => {  swal("Transaction successfull", { buttons: false, icon: "success", timer: 2000 }) }, 500);  
            }else{
                handleShowTimer(true)
                $('.ajax-loader').css("display", "none");
                setTimeout(() => {  swal("Error while processing your request",{ buttons: false, icon: "success", timer: 2000 }) }, 500);
            }
          });
    }

    const purchagepage = async(next) =>{

        if(account !== null && account !== undefined && account !== ''){
            console.log(duration, account, fee)
            await currencyDetails.airDropContract.methods.becomeMember(duration).send({ from: account, value: fee}, function (err, result) {
                if (err) {
                    swal("Transaction Error", {icon: "error", buttons: false, timer: 2000 });
                }
                if (result) {
                    swal( "Your transaction is sent, Please wait for confirmation.", {icon: "success", buttons: false, timer: 2000 });
                    setTimeout(() => { $('.ajax-loader').css("display", "flex"); }, 2000);
                }
            // eslint-disable-next-line no-loop-func
            }).on('receipt', function (receipt) {
                if (receipt.status === true) {
                    let tx = receipt.transactionHash
                    next(account,tx,fee);
                    // setTimeout(() => {  swal({ title: "Transaction successfull", icon: "success", buttons: false, timer: 2000 }) }, 2000);
                } else {
                    $('.ajax-loader').css("display", "none"); 
                    setTimeout(() => { swal("Transaction Error", {icon: "error", buttons: false, timer: 2000 }); }, 500);
                }
            })
        }else{
            swal("Please connect to the wallet", { buttons: false, icon: "error", timer: 1000 });
        }
        
    }

    useEffect(()=>{
        let isApiSubscribed = true; 
        if(isApiSubscribed){
            if(account){
                props.handleErrMsg(false)
                currencyDetails.airDropContract.methods.getVIPMembershipFee(duration).call().then((charge)=>{
                    setFee(charge);
                    isApiSubscribed = false
                })
            }else{
                props.handleErrMsg(true)
            }
             
        }
        return () =>{
            isApiSubscribed = false; 
        }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   },[currencyDetails.airDropContract, duration, account]);

  return (
    <div className="col-md-3 col-lg-3 col-12 v-m-div">
        <div className="innfour inn-text">
            <p>Duration: {duration} day</p>
            <p>Cost: {Number(fee)/10**18} {currency.toUpperCase()}</p>
            <button type="button" onClick = {()=>{purchagepage(saveVip)}}>
                Purchase
            </button>
        </div>
    </div>
  )
}

export default PurchaseBox